import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Vacancy.css";

function Vacancy() {
  const [vacancies, setVacancies] = useState([]);
  const [title, setTitle] = useState("");
  const [experience, setExperience] = useState("");
  const [salary, setSalary] = useState("");
  const [gender, setGender] = useState("");
  const [place, setPlace] = useState("");
  const [message, setMessage] = useState(""); // State for status message

  // Fetch vacancies when the component mounts
  useEffect(() => {
    axios
      .get("https://weynibirhan.com.et/vacancies.php") // Use your live host URL here
      .then((response) => {
        setVacancies(response.data);
      })
      .catch((error) => {
        console.error("Error fetching vacancies:", error);
      });
  }, []);

  // Handle form submission for creating a new vacancy
  const handleSubmit = (e) => {
    e.preventDefault();

    const vacancyData = {
      title,
      experience,
      salary,
      gender,
      place,
    };

    // Log the data being submitted
    console.log("Posting Vacancy with data:", vacancyData);

    axios
      .post("https://weynibirhan.com.et/vacancies.php", vacancyData) // Use your live host URL here
      .then((response) => {
        console.log("Vacancy posted successfully:", response);
        setVacancies([response.data, ...vacancies]); // Add the new vacancy to the state
        setTitle("");
        setExperience("");
        setSalary("");
        setGender("");
        setPlace("");
        setMessage("Vacancy posted successfully!"); // Success message
      })
      .catch((error) => {
        console.error("Error creating vacancy:", error);
        setMessage("Failed to post vacancy. Please try again."); // Error message
      });
  };

  return (
    <div className="App">
      <h1>Job Vacancies</h1>

      {/* Vacancy Input Form */}
      <h2>Add a New Vacancy</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Title: </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Experience (years): </label>
          <input
            type="number"
            value={experience}
            onChange={(e) => setExperience(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Salary: </label>
          <input
            type="number"
            value={salary}
            onChange={(e) => setSalary(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Gender: </label>
          <input
            type="text"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Location: </label>
          <input
            type="text"
            value={place}
            onChange={(e) => setPlace(e.target.value)}
            required
          />
        </div>
        <button type="submit">Post Vacancy</button>
      </form>

      {/* Display success or error message */}
      {message && <p className="message">{message}</p>}

      {/* Display Vacancies */}
      <h2>Available Vacancies</h2>
      <ul>
        {vacancies.map((vacancy) => (
          <li key={vacancy.id}>
            <h3>{vacancy.title}</h3>
            <p>Experience: {vacancy.experience} years</p>
            <p>Salary: {vacancy.salary}</p>
            <p>Gender: {vacancy.gender}</p>
            <p>Location: {vacancy.place}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Vacancy;
